module.exports = __webpack_public_path__ + "img/aspect-ratio-4-3-d.900342e4.svg";